import { render, staticRenderFns } from "./BidderIsWinner.vue?vue&type=template&id=308d9ab8"
import script from "./BidderIsWinner.vue?vue&type=script&lang=js"
export * from "./BidderIsWinner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports